import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { DeviationTypes } from '../../../../../../types/deviation';
import { getDeviationType, getDeviationUrl } from '../../../../../_helpers';
import { useWatchButton } from '../../../../../../WatchButton/useWatchButton';
const unlockHint = (type, isMobile)=>{
    if (type === DeviationTypes.FILM) {
        return isMobile ? 'deviationview.overlay.premiumFolder.unlockHint.watch.mobile.video' : 'deviationview.overlay.premiumFolder.unlockHint.watch.video';
    }
    return isMobile ? 'deviationview.overlay.premiumFolder.unlockHint.watch.mobile' : 'deviationview.overlay.premiumFolder.unlockHint.watch';
};
const WatchersOnlyMiddleContent = ({ deviation, thumbWidth, thumbHeight, className })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const redirectOnWatch = useCallback(()=>{
        window.location.href = getDeviationUrl(deviation);
    }, [
        deviation
    ]);
    const { text, onClick, biData } = useWatchButton(deviation.author, undefined, undefined, false, redirectOnWatch);
    const canShowDescription = thumbWidth && thumbWidth > 150 && (thumbWidth > 270 ? thumbHeight && thumbHeight > 240 : thumbHeight && thumbHeight > 260);
    const canShowButton = thumbHeight && thumbHeight > 210;
    const isUnreasonablySmall = thumbHeight && thumbHeight < 160 || thumbWidth && thumbWidth < 120;
    if (isUnreasonablySmall) {
        return /*#__PURE__*/ React.createElement(HoverOnly, {
            reverseHidden: true
        }, /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
            icon: /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
                type: "watchers-only-folder",
                size: "large"
            }),
            className: className
        }));
    }
    return /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
        icon: /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
            type: "watchers-only-folder",
            size: "large"
        }),
        subtitle: canShowDescription ? t(unlockHint(getDeviationType(deviation), isMobile)) : undefined,
        buttonTitle: canShowButton ? text : undefined,
        onButtonClick: onClick,
        biData: biData,
        className: className
    });
};
WatchersOnlyMiddleContent.displayName = 'WatchersOnlyMiddleContent';
export default WatchersOnlyMiddleContent;

//# sourceMappingURL=WatchersOnlyMiddleContent.js.map